"use client";

import { c as _c } from "react/compiler-runtime";
import { Icon } from "@justhome/react-ui";
import Section, { Ground } from "@modules/homepage-v2/components/Section";
import SectionHead from "@modules/homepage-v2/components/SectionHead";
import SectionImage from "@modules/homepage-v2/components/SectionImage";
import { TestimonialSection } from "@modules/homepage-v2/lib/getSections";
import { useTranslations } from "next-intl";
import { useState } from "react";
const SIZES = "(min-width: 960px) 480px, 100vw";
const Arrow = t0 => {
  const $ = _c(8);
  const {
    direction,
    label,
    disabled,
    onClick
  } = t0;
  const t1 = `w-[44px] h-[44px] rounded-full border border-neutral-50 bg-neutral-0 flex items-center justify-center transition-colors ${disabled ? "opacity-75 cursor-default text-neutral-50" : "hover:bg-neutral-12 cursor-pointer text-neutral-425"}`;
  const t2 = direction === "prev" ? "rotate-90" : "-rotate-90";
  let t3;
  if ($[0] !== t2) {
    t3 = <Icon type="Down" size={20} fill="currentColor" className={t2} />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== disabled || $[3] !== label || $[4] !== onClick || $[5] !== t1 || $[6] !== t3) {
    t4 = <button type="button" onClick={onClick} disabled={disabled} aria-label={label} className={t1}>{t3}</button>;
    $[2] = disabled;
    $[3] = label;
    $[4] = onClick;
    $[5] = t1;
    $[6] = t3;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  return t4;
};
const Testimonial = t0 => {
  const $ = _c(25);
  const {
    section,
    ground
  } = t0;
  const t = useTranslations("homepage-v2");
  const [current, setCurrent] = useState(0);
  let T0;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[0] !== current || $[1] !== ground || $[2] !== section.headline || $[3] !== section.items || $[4] !== t) {
    t6 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const items = (section.items ?? []).filter(_temp);
      if (!items.length) {
        t6 = null;
        break bb0;
      }
      const many = items.length > 1;
      T0 = Section;
      t4 = ground;
      if ($[12] !== section.headline) {
        t5 = section.headline && <SectionHead headline={section.headline} />;
        $[12] = section.headline;
        $[13] = t5;
      } else {
        t5 = $[13];
      }
      t1 = `grid gap-2m ${section.headline ? "mt-2m" : ""}`;
      let t7;
      if ($[14] !== current) {
        t7 = (item_0, index) => {
          const shown = index === current;
          return <figure key={item_0.authorName} className={`m-none [grid-area:1/1] transition-opacity duration-150 grid gap-2m m:grid-cols-[minmax(0,1fr)_minmax(0,1.05fr)] items-center ${shown ? "opacity-100" : "opacity-0 invisible pointer-events-none"}`} aria-hidden={shown ? undefined : "true"}><div className="max-w-[62ch] m:order-2"><blockquote className="text-h3 font-book italic m-none">„{item_0.quote}“</blockquote><figcaption className="mt-2s text-body-2">{item_0.authorHref ? <a href={item_0.authorHref} target="_blank" rel="noopener noreferrer" className="font-semibold no-underline hover:text-primary-800">{item_0.authorName}</a> : <span className="font-semibold">{item_0.authorName}</span>}{item_0.authorRole && <span className="text-neutral-425">{" "}· {item_0.authorRole}</span>}</figcaption></div><SectionImage image={item_0.image} sizes={SIZES} ratio="ratio_1_1" className="max-w-[480px] rounded-m justify-self-center m:justify-self-start m:order-1" /></figure>;
        };
        $[14] = current;
        $[15] = t7;
      } else {
        t7 = $[15];
      }
      t2 = <div className="grid" aria-live="polite">{items.map(t7)}</div>;
      t3 = many && <div className="flex items-center gap-3s"><div className="flex items-center gap-2xs"><Arrow direction="prev" label={t("testimonial_previous")} disabled={current === 0} onClick={() => setCurrent(current - 1)} /><Arrow direction="next" label={t("testimonial_next")} disabled={current === items.length - 1} onClick={() => setCurrent(current + 1)} /></div><div className="flex items-center" role="tablist" aria-label={t("testimonial_group")}>{items.map((item_1, index_0) => <button key={item_1.authorName} type="button" role="tab" aria-selected={index_0 === current} aria-label={t("testimonial_nth", {
            position: index_0 + 1,
            total: items.length,
            name: item_1.authorName
          })} onClick={() => setCurrent(index_0)} className="w-[24px] h-[24px] p-none border-none bg-transparent flex items-center justify-center cursor-pointer"><span className={`block w-[8px] h-[8px] rounded-full transition-colors ${index_0 === current ? "bg-primary-800" : "bg-neutral-50"}`} /></button>)}</div></div>;
    }
    $[0] = current;
    $[1] = ground;
    $[2] = section.headline;
    $[3] = section.items;
    $[4] = t;
    $[5] = T0;
    $[6] = t1;
    $[7] = t2;
    $[8] = t3;
    $[9] = t4;
    $[10] = t5;
    $[11] = t6;
  } else {
    T0 = $[5];
    t1 = $[6];
    t2 = $[7];
    t3 = $[8];
    t4 = $[9];
    t5 = $[10];
    t6 = $[11];
  }
  if (t6 !== Symbol.for("react.early_return_sentinel")) {
    return t6;
  }
  let t7;
  if ($[16] !== t1 || $[17] !== t2 || $[18] !== t3) {
    t7 = <div className={t1}>{t2}{t3}</div>;
    $[16] = t1;
    $[17] = t2;
    $[18] = t3;
    $[19] = t7;
  } else {
    t7 = $[19];
  }
  let t8;
  if ($[20] !== T0 || $[21] !== t4 || $[22] !== t5 || $[23] !== t7) {
    t8 = <T0 ground={t4}>{t5}{t7}</T0>;
    $[20] = T0;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
};
export default Testimonial;
function _temp(item) {
  return item.quote && item.authorName;
}